import type { HmlMyCampaignCalendarStatisticsModel } from '~/components/ChecklistCalendar.vue'

export interface HmlMyCampaignStatisticsModel {
  countPerItem: Record<number, number>
  engagementCount: number
  engagementDays: number
  volunteerCount: number
}

export default function () {
  const { $api } = useNuxtApp()
  const { jwtCookie } = useAuth()

  async function fetchMyCheckedItems(params: { date: Date }) {
    const dateString = formatYYYYmmdd(params.date)
    return $api<Record<number, boolean>>('/hml/v1/me/campaign-items/checked', {
      method: 'GET',
      query: { date: dateString },
    })
  }

  async function toggleItem(params: { campaignItemId: number, date: Date }) {
    const dateString = formatYYYYmmdd(params.date)
    await $api(`/hml/v1/me/campaign-items/${params.campaignItemId}/toggle`, {
      method: 'POST',
      body: { date: dateString },
    })
  }

  async function fetchMyCampaignStatistics(yearMonth?: string) {
    if (!jwtCookie.value) {
      return null
    }
    return $api<HmlMyCampaignStatisticsModel>('/hml/v1/me/campaign/statistics', {
      method: 'GET',
      query: { yearMonth },
    })
  }

  async function fetchMyCampaignStatisticsCalendar(yearMonth: string) {
    if (!jwtCookie.value) {
      return null
    }
    return $api<HmlMyCampaignCalendarStatisticsModel[]>('/hml/v1/me/campaign/statistics/calendar', {
      method: 'GET',
      query: { yearMonth },
    })
  }

  return {
    toggleItem,
    fetchMyCheckedItems,
    fetchMyCampaignStatistics,
    fetchMyCampaignStatisticsCalendar,
  }
}
